<template>
  <v-card class="tools-view-card">
    <ToolbarHeader :name="'JWT Debugger'"/>
    <v-container>
      <section class="ma-5">
        <v-row>
          <v-col cols="12"
                 sm="6"
                 md="6">
            <v-form
                v-model="formOptions.valid"
            >
              <label>
                Token
              </label>
              <editor
                  v-model="form.token"
                  @init="initTextEditor"
                  width="100%"
                  height="70vh">
              </editor>
              <v-btn
                  :disabled="!formOptions.valid"
                  @click="formSubmit"
                  color="primary"
                  class="mr-4 mt-3"
              >
                Debug JWT
              </v-btn>
            </v-form>
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="6"
          >
            <v-row>
              <label>
                Header
              </label>
              <editor
                  :value="debugResult.header"
                  @init="initJSONEditor"
                  width="100%"
                  height="30vh">
              </editor>
            </v-row>

            <v-row class="mt-5">
              <label>
                Payload
              </label>
              <editor
                  :value="debugResult.payload"
                  @init="initJSONEditor"
                  width="100%"
                  height="30vh">
              </editor>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const form = {
  token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ'
};


export default {
  name: "JWT-Debugger",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader,
  },
  data: () => ({
    form: Object.assign({}, form),
    formOptions: {
      valid: false,
      decode: [
        v => !!v || 'Token is required',
      ],
    },
    debugResult: {
      header: '',
      payload: ''
    }
  }),
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    formSubmit() {
      if (!this.form.token) {
        return;
      }

      this.resetDebugResult();

      try {
        this.parseJwt(this.form.token);
      } catch (e) {
        this.resetDebugResult();
        throw new Error(e);
      }
    },
    resetDebugResult() {
      this.debugResult.header = '';
      this.debugResult.payload = '';
    },
    parseJwt(token) {
      const splitToken = token.split('.'[0]);

      const header = JSON.parse(window.atob(splitToken[0]));
      const payload = JSON.parse(window.atob(splitToken[1]));

      this.debugResult.header = JSON.stringify(header, undefined, 4);
      this.debugResult.payload = JSON.stringify(payload, undefined, 4);
    }
  }
}
</script>

<style scoped>

</style>
